import { render } from "./myClass.vue?vue&type=template&id=d2fa626e"
import script from "./myClass.vue?vue&type=script&lang=js"
export * from "./myClass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__